'use client';

import { useEffect } from 'react';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    freestar: any;
  }
}

// http://live.primis.tech/live/*
const FreeStarVideo = () => {
  useEffect(() => {
    window?.freestar?.queue?.push(function () {
      window?.freestar?.newVideo('FreeStarVideoAdContainer_Slider');
    });
  }, []);

  return null;
};

export default FreeStarVideo;
